import { View, ViewStyle } from 'react-native';
import { style } from './BottomSheetSourceUpload.style';
import TextLato from '../text/text-lato/TextLato';
import { TestIDs } from 'src/constants/testIDs.constants';
import { bottomSheetTestID } from 'src/helpers/testIDs.helper';
import { CircularButton } from '../buttons/circular-button/CircularButton';
import { CIRCULAR_BUTTON_SIZES, CIRCULAR_BUTTON_TYPES } from '../buttons/circular-button/CircularButton.constants';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { ICON_NAMES } from '../icon/icon.helper';
import { useStore } from 'src/contexts/StoreContext';
import { Icon } from '../icon/Icon';
import {
  DYNAMIC_MODAL_VIEWS,
  SELECTED_MENU_ITEMS,
} from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { neutrals } from 'src/theme/colors';
import { observer } from 'mobx-react-lite';
import Button from '../buttons/button/Button';
import { PickedImage } from '@photosi/expo-photosi-sdk/build/ImageLibrary';
import { pickImages } from 'src/store/_shared/imagePickerUtils';
import {
  SourcesEventType,
  sourcesMobileNew,
} from '../modals/dynamic-modals/modal-upload-multisource/ModalUploadMultisource.constants';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { BottomSheetScrollView } from '@gorhom/bottom-sheet';

const iconsMap = {
  [SELECTED_MENU_ITEMS.Gallery]: ICON_NAMES.PhotoAlbum,
  [SELECTED_MENU_ITEMS.Computer]: ICON_NAMES.PhotoAlbum,
  [SELECTED_MENU_ITEMS.GooglePhoto]: ICON_NAMES.GooglePhoto,
  [SELECTED_MENU_ITEMS.Smartphone]: ICON_NAMES.Smartphone2,
  [SELECTED_MENU_ITEMS.FamilyFriends]: ICON_NAMES.People2,
};

export const BottomSheetSourceUpload = observer(({ bsStyle }: { bsStyle: ViewStyle }) => {
  const {
    i18n,
    bottomSheet,
    dynamicModal: { openModal, closeModal },
    project,
    toastStore,
    photoDrawer,
  } = useStore();

  const onPress = async (source: SELECTED_MENU_ITEMS) => {
    bottomSheet.closeBottomSheet();
    openModal({
      dynamicModalView: DYNAMIC_MODAL_VIEWS.UploadMultiSource,
      selectedMenuItem: source,
      newUploadMultiSourceCallback: params => {
        project.startAddingPhotosFlow({
          initialProductConfigurationId: project.activeGroup?.productConfigurationIdDefault,
          groupCode: project.activeGroup?.code,
          skipConfigurationSteps: [],
          groupId: project.activeGroup?.id,
          ...params,
        });
      },
    });
    if (source === SELECTED_MENU_ITEMS.Gallery) {
      const productImages: PickedImage[] = await pickImages({
        allowsMultipleSelection: true,
        i18n,
        errorCallback: ({ areAllPhotosInvalid, errorMessage }) => {
          if (areAllPhotosInvalid) {
            closeModal();
          }
          toastStore.showErrorToast({
            id: 'alert-uploading-photos-error-toast',
            message: errorMessage,
          });
        },
      });
      const autoselect = project.activeProject?.thumbnailImages.length == 0;
      if (productImages.length) {
        amplitude.trackEvent(AnalyticsEvents.dynamicPicker.choosePhotosClick, {
          source_type: SourcesEventType.Computer,
        });
        
        productImages.forEach(file => (file.source = SELECTED_MENU_ITEMS.Gallery));
        await project.activeProject?.addImages(productImages).then(() => {
          /*  project.activeProject?.loadThumbnailImages().then(() => { */
          if (autoselect) {
            project.activeProject?.thumbnailImages.forEach(image => {
              photoDrawer.addImageId(image.originalImageId);
            });
          }
          /*  }); */
        });

        amplitude.trackEvent(AnalyticsEvents.dynamicPicker.sourcePhotoUploaded, {
          n_photo: productImages.length,
          source_type: SourcesEventType.Computer,
        });
      }
    }
  };

  return (
    <BottomSheetScrollView contentContainerStyle={bsStyle}>
      <View style={style.container}>
        <View style={style.header}>
          <TextLato style={style.title}>{i18n.t('photo-drawer:upload-more')}</TextLato>
          <CircularButton
            size={CIRCULAR_BUTTON_SIZES.SMALL}
            type={CIRCULAR_BUTTON_TYPES.ONLY_ICON}
            testID={bottomSheetTestID(TestIDs.CLOSE)}
            focusId={bottomSheetTestID(TestIDs.CLOSE)}
            focusGroup={FocusGroups.MODAL}
            focusOrder={0}
            iconName={ICON_NAMES.Close}
            iconStyle={style.iconClose}
            onPress={async () => bottomSheet.closeBottomSheet()}
          />
        </View>
        <View>
          {sourcesMobileNew.map((source, index) => {
            return (
              <Button
                testID={bottomSheetTestID(TestIDs.UPLOAD_PHOTO, TestIDs.PICKER_SOURCE, source)}
                focusId={bottomSheetTestID(TestIDs.UPLOAD_PHOTO, TestIDs.PICKER_SOURCE, source)}
                focusOrder={index + 1}
                focusGroup={FocusGroups.BOTTOM_SHEET}
                onPress={async () => onPress(source)}
                key={`bottom-sheet-source-upload-${source}`}
              >
                {() => (
                  <View style={style.listItem}>
                    <View style={style.itemIcon}>
                      <Icon name={iconsMap[source]} color={neutrals.neutralGrays.cement} />
                    </View>
                    <TextLato style={style.itemText}>{i18n.t(`upload:${source}`)}</TextLato>
                  </View>
                )}
              </Button>
            );
          })}
        </View>
      </View>
    </BottomSheetScrollView>
  );
});
